module.exports = __webpack_public_path__ + "img/bbc-radio-1.30f9a64c.png";